@if (displayMessage()?.length) {
    <div
        class="form-error-note"
        [innerHTML]="displayMessage()"
        aria-live="polite"
        [id]="errorId()"
    ></div>
}
